import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProjectsService from "../../api/projectsService";
import TechnologiesService from "../../api/technologiesService";
import UsersService from "../../api/usersService";

const DashboardPage = () => {
  const [stats, setStats] = useState({
    totalProjects: 0,
    activeProjects: 0,
    totalTechnologies: 0,
    totalUsers: 0,
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const [projects, technologies, users] = await Promise.all([
          ProjectsService.getAll(),
          TechnologiesService.getAll(),
          UsersService.getAll(),
        ]);

        const activeProjects = projects.filter((project) => project.isActive);

        setStats({
          totalProjects: projects.length,
          activeProjects: activeProjects.length,
          totalTechnologies: technologies.length,
          totalUsers: users.length,
        });
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Welcome to your portfolio admin dashboard. Here's an overview of your
        content.
      </Typography>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            sx={{
              p: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Total Projects
            </Typography>
            <Typography variant="h3" color="primary">
              {stats.totalProjects}
            </Typography>
            <Button
              variant="text"
              onClick={() => navigate("/admin/projects")}
              sx={{ mt: 2 }}
            >
              Manage Projects
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            sx={{
              p: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Active Projects
            </Typography>
            <Typography variant="h3" color="success.main">
              {stats.activeProjects}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {Math.round((stats.activeProjects / stats.totalProjects) * 100) ||
                0}
              % of total
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            sx={{
              p: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Technologies Used
            </Typography>
            <Typography variant="h3" color="info.main">
              {stats.totalTechnologies}
            </Typography>
            <Button
              variant="text"
              onClick={() => navigate("/admin/technologies")}
              sx={{ mt: 2 }}
            >
              Manage Technologies
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            sx={{
              p: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Admin Users
            </Typography>
            <Typography variant="h3" color="secondary.main">
              {stats.totalUsers}
            </Typography>
            <Button
              variant="text"
              onClick={() => navigate("/admin/users")}
              sx={{ mt: 2 }}
            >
              Manage Users
            </Button>
          </Paper>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
        <Button
          variant="contained"
          onClick={() => navigate("/admin/projects/new")}
        >
          Add New Project
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/admin/technologies/new")}
        >
          Add New Technology
        </Button>
        <Button variant="outlined" onClick={() => navigate("/admin/users")}>
          Manage Users
        </Button>
      </Box>
    </Box>
  );
};

export default DashboardPage;
